import { render, staticRenderFns } from "./player-balance-chart.vue?vue&type=template&id=e8d56af6&scoped=true&"
import script from "./player-balance-chart.vue?vue&type=script&lang=js&"
export * from "./player-balance-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d56af6",
  null
  
)

export default component.exports